export interface DeleteGroupDto
{
    getMsisdn(): string;
    getGroupId(): string;
    getGroupName(): string;
    getLanguage(): string;
}

export class DeleteGroupDtoImpl implements DeleteGroupDto
{
    private msisdn: string;
    private groupId: string;
    private groupName: string;
    private language: string;

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string
    {
        return this.msisdn;
    }
    
    getGroupId(): string
    {
        return this.groupId;
    }
    setGroupId(groupId: string)
    {
        this.groupId = groupId;
    }

    setGroupName(groupName: string)
    {
        this.groupName = groupName;
    } 
    getGroupName(): string 
    {
        return this.groupName;
    }

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/deletegroup/deletegroupdto.ts